import React from "react";
import { useDispatch } from "react-redux";
import {
  selecteProject,
  UnSelecteProject
} from "../../features/Task/TaskSlice";

const ProjectsList = ({ project }) => {
  const dispatch = useDispatch();

  return (
    <>
      <div className="checkbox-container">
        <input
          onChange={(e) =>
            e.target.checked
              ? dispatch(selecteProject(project?.projectName))
              : dispatch(UnSelecteProject(project?.projectName))
          }
          type="checkbox"
          className={`${project?.colorClass}`}
          defaultChecked
        />
        <p className="label">{project?.projectName}</p>
      </div>
    </>
  );
};

export default ProjectsList;
